<div
    class="py-3"
    [formGroup]="form()">
    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="name"
            required="true"
            focus="true"
            label="Room Content Name" />

        <name-validation-errors
            [formGroup]="form()"
            id="name"
            label="Room Content  Name" />
    </div>

    <div class="mb-4">
        <category-selection-list
            [categories]="categories()"
            [formGroup]="form()"
            required="true"
            id="category" />
    </div>


</div>
